import { useParams, useSearch } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { SubscriptionCheckoutPage } from './SubscriptionCheckoutPage';

export function SubscriptionCheckoutRoute(): ReactElement {
    const { token } = useParams({ strict: false });
    const { payment } = useSearch({ strict: false });
    return <SubscriptionCheckoutPage token={token ?? ''} payment={payment} />;
}
